import { getImage } from '@utils/imageHelper';

// eslint-disable-next-line import/prefer-default-export
export const categoryIdIconMap = {
  81000187577: getImage('helpCenter/payments.svg'),
  81000187579: getImage('helpCenter/myCourses.svg'),
  81000187743: getImage('helpCenter/testSeries.svg'),
  81000193354: getImage('helpCenter/technicalIssues.svg'),
  81000193487: getImage('helpCenter/guideToUnacademy.svg'),
  81000195729: getImage('helpCenter/letsBegin.svg'),
  chat: getImage('helpCenter/chat.svg')
};
